import ENV from "config/Env";
import { backendQueryKey } from "hooks/useTypedQuery";

export enum PLAN_IT_BINARY_VALUES {
  No = 0,
  Yes
}

export enum PLAN_IT_DELIVER_TYPE {
  CarCompanyDeliversCustomer = 1,
  CarCompanyDeliversCar
}

export type PlanITReplacementVehicleInfo = {
  Street?: string;
  HouseNumber?: string;
  ZipCode?: string;
  City?: string;
  Remark?: string;
};

export type PlanITDocumentationInfoType = {
  WorkorderNumber: string;
  PlanDate: string;
  PlanEndDate: string;
  PlanTime: number;
  PlanEndTime: number;
  Waits: PLAN_IT_BINARY_VALUES;
  WaitsTime: number;
  Deadline: string;
  DeadlineTime: number;
  SmsWhenReady: PLAN_IT_BINARY_VALUES;
  TimeAppointment: PLAN_IT_BINARY_VALUES;
  TimeAppointmentDeliverDate: string;
  TimeAppointmentDeliverTime: number;
  TimeAppointmentCollectDate: string;
  TimeAppointmentCollectTime: number;
  Deliver: PLAN_IT_BINARY_VALUES;
  DeliverType: PLAN_IT_DELIVER_TYPE;
  DeliverDate: string;
  DeliverTime: number;
  Collect: PLAN_IT_BINARY_VALUES;
  CollectType: number;
  CollectDate: string;
  CollectTime: number;
  Reception: string;
  ReceptionPhone: string;
  ReceptionEmail: string;
  ReceptionFunction: string;
  Mechanic: string;
  Mechanic_ID: number;
  PinBoard: PLAN_IT_BINARY_VALUES;
  RentWise: PLAN_IT_BINARY_VALUES;
  VehicleType: string;
  ReplacementVehicle: PLAN_IT_BINARY_VALUES;
  ReplacementVehicleType: number;
  ReplacementVehicleBill: string;
  ReplacementVehicleRegistrationNumber: string;
  ReplacementVehiclePlanDate: string;
  ReplacementVehiclePlanEndDate: string;
  ReplacementVehiclePlanTime: number;
  ReplacementVehiclePlanEndTime: number;
  ReplacementVehicleCollectInfo: PlanITReplacementVehicleInfo;
  ReplacementVehicleDeliverInfo: PlanITReplacementVehicleInfo;
};

export const PlanITQueryKeys = {
  data: backendQueryKey<PlanITDocumentationInfoType>({ component: "PlanIT", baseUrl: ENV.planitBaseURL, endpoint: "/appointments/details" })
};
